import { logger } from "cayo.ui";
import {
  isDate,
  isNullOrEmpty,
  isNullOrWhiteSpace,
  isString,
  isUndefined,
} from "@cayo/shared/types/typeGuards";

const log = logger.getLogger("GenerationRuleUtils");

function getInternetExplorerVersion() {
  let rv = -1;
  if (navigator.userAgent === "Microsoft Internet Explorer") {
    const ua = navigator.userAgent;
    const re = new RegExp("MSIE ([0-9]{1,}[.0-9]{0,})");
    if (re.exec(ua) !== null) {
      rv = parseFloat(RegExp.$1);
    }
  }
  return rv;
}

const trimFunction = (function () {
  function escapeRegex(string: string) {
    return string.replace(/[[\](){}?*+^$\\.|-]/g, "\\$&");
  }

  return function trim(str: unknown, characters: unknown, flags?: unknown) {
    flags = flags || "g";
    if (typeof str !== "string" || typeof characters !== "string" || typeof flags !== "string") {
      throw new TypeError("argument must be string");
    }

    if (!/^[gi]*$/.test(flags)) {
      throw new TypeError("Invalid flags supplied '" + flags.match(new RegExp("[^gi]*")) + "'");
    }

    characters = escapeRegex(characters);

    return str.replace(new RegExp("[" + characters + "]", flags), "");
  };
})();

/*Generate supports -->*/
/*
  type:
    0 - All Tokens should be not empty
    1 - Any Token is not empty
    2 - All Tokens should be empty
    3 - Property equal specified one of value (valToCheck)
*/
function GReturnByCondition(
  inplist: any[],
  res: any,
  type: 0 | 1 | 2 | 3 | 4,
  valToCheck: any[] | null
) {
  let ret = true;
  if (type === 0) {
    inplist.forEach((value: unknown) => {
      if (isNullOrWhiteSpace(value)) {
        ret = false;
      }
    });
  }
  if (type === 1) {
    ret = false;
    inplist.forEach((value: unknown) => {
      if (!isNullOrWhiteSpace(value)) {
        ret = true;
      }
    });
  }
  if (type === 2) {
    inplist.forEach((value: unknown) => {
      if (!isNullOrWhiteSpace(value)) {
        ret = false;
      }
    });
  }
  if (type === 3 && valToCheck !== null && Array.isArray(valToCheck)) {
    ret = false;
    inplist.forEach((value: string) => {
      if (!isNullOrWhiteSpace(value)) {
        let inArray = false;
        const valueLower = value.toLowerCase();
        valToCheck.forEach((arval) => {
          if (!isNullOrWhiteSpace(arval) && arval.toLowerCase() === valueLower) {
            inArray = true;
          }
        });
        ret = inArray;
      }
    });
  }
  if (type === 4 && valToCheck !== null && Array.isArray(valToCheck)) {
    ret = false;
    inplist.forEach((value: string) => {
      if (!isNullOrWhiteSpace(value)) {
        let inArray = false;
        const valueLower = value.toLowerCase();
        valToCheck.forEach((arval) => {
          if (!isNullOrWhiteSpace(arval) && arval.toLowerCase() !== valueLower) {
            inArray = true;
          }
        });
        ret = inArray;
      }
    });
  }
  if (ret) {
    return res;
  }
  return "";
}

function GReturnBothNotEmpty(inp1: unknown, inp2: unknown, res: any) {
  if (!isNullOrWhiteSpace(inp1) && !isNullOrWhiteSpace(inp2)) {
    return res;
  }
  return "";
}

function GReturnIfNotEmpty(inp1: unknown, res: any) {
  if (!isNullOrWhiteSpace(inp1)) {
    return res;
  }
  return "";
}

function GtoLowerCase(inp: unknown) {
  if (isString(inp) && !isNullOrWhiteSpace(inp)) {
    return inp.toLowerCase();
  }
  return "";
}

function GtoUpperCase(inp: unknown) {
  if (isString(inp) && !isNullOrWhiteSpace(inp)) {
    return inp.toUpperCase();
  }
  return "";
}

function GRemoveSpaces(inp: unknown) {
  if (isString(inp) && !isNullOrWhiteSpace(inp)) {
    return inp.replace(/\s+/g, "");
  }
  return "";
}

function GFirst(inp: unknown, count?: number) {
  if (isString(inp) && !isNullOrWhiteSpace(inp)) {
    return inp.substring(0, count);
  }
  return "";
}

function GLast(inp: unknown, count: number) {
  if (isString(inp) && !isNullOrWhiteSpace(inp)) {
    return inp.slice(-count);
  }
  return "";
}

function GJoinBySpaces(tokens: string[]) {
  const res: string[] = [];
  tokens.forEach((value: string) => {
    if (!isNullOrWhiteSpace(value)) {
      res.push(value.trim());
    }
  });
  if (res.length > 0) {
    return res.join(" ");
  }
  return "";
}

function GJoinByChar(tokens: any[], splitter?: string): string {
  const res: string[] = [];
  tokens.forEach((value: string) => {
    if (!isNullOrWhiteSpace(value)) {
      res.push(value.trim());
    }
  });
  if (res.length > 0) {
    return res.join(splitter);
  }
  return "";
}

function GJoinBySpacesF(tokens: any[]) {
  const res: string[] = [];
  tokens.forEach((value: string) => {
    if (!isNullOrEmpty(value)) {
      res.push(value);
    }
  });
  if (res.length > 0) {
    return GTrim(res.join(" "));
  }
  return "";
}

function GJoinByCharF(tokens: any[], splitter?: string) {
  const res: string[] = [];
  tokens.forEach((value: any) => {
    if (!isNullOrEmpty(value)) {
      res.push(value);
    }
  });
  if (res.length > 0) {
    return GTrim(res.join(splitter));
  }
  return "";
}

function GExcludeCharacters(inp: unknown, exclude: any) {
  if (isString(inp) && !isNullOrWhiteSpace(inp)) {
    return trimFunction(inp, exclude);
  }
  return "";
}

function GSubstituteCharacters(inp: unknown, remap: string) {
  if (isString(inp) && !isNullOrWhiteSpace(remap)) {
    const splitedtokens = remap.split(",");
    const replaces: any[] = [];
    splitedtokens.forEach((value: string) => {
      if (!isNullOrWhiteSpace(value)) {
        const spltTmp = value.split(">");
        if (
          spltTmp.length === 2 &&
          !isNullOrWhiteSpace(spltTmp[0]) &&
          !isNullOrWhiteSpace(spltTmp[1])
        ) {
          if (spltTmp[0] === "[space]") {
            spltTmp[0] = " ";
          }
          if (spltTmp[1] === "[space]") {
            spltTmp[1] = " ";
          }
          replaces.push({ find: spltTmp[0], replace: spltTmp[1] });
        }
      }
    });
    if (replaces.length > 0) {
      let fixed = inp;
      replaces.forEach((value) => {
        //fixed = fixed.replace(value.find, value.replace);
        fixed = fixed.split(value.find).join(value.replace);
      });
      return fixed;
    }
  }
  return "";
}

function GReturnIfGreater(inp: unknown, val: number) {
  if (isString(inp) && !isNullOrWhiteSpace(inp)) {
    if (inp.length > val) {
      return inp;
    }
  }
  return "";
}

function GReturnIfGreaterOrEqual(inp: unknown, val: number) {
  if (isString(inp) && !isNullOrWhiteSpace(inp)) {
    if (inp.length >= val) {
      return inp;
    }
  }
  return "";
}

function GReturnIfLess(inp: unknown, val: number) {
  if (isString(inp) && !isNullOrWhiteSpace(inp)) {
    if (inp.length < val) {
      return inp;
    }
  }
  return "";
}

function GReturnIfLessOrEqual(inp: unknown, val: number) {
  if (isString(inp) && !isNullOrWhiteSpace(inp)) {
    if (inp.length <= val) {
      return inp;
    }
  }
  return "";
}

function GAddDaysIfLessOrEqual(inp: unknown, old: Buffer, count: any) {
  if (isUndefined(inp) || isUndefined(old)) {
    return old !== null ? old.toJSON() : null;
  }
  if (isDate(inp) && isDate(old) && old <= inp) {
    const tomorrow = new Date(inp);
    tomorrow.setDate(inp.getDate() + count);
    return tomorrow.toJSON();
  }

  return old !== null ? old.toJSON() : null;
}

function GGetRandomChars(count: number, excludeCharsList: string, caseMode: unknown) {
  if (isUndefined(count)) {
    count = 3;
  }
  if (isUndefined(caseMode)) {
    caseMode = 0;
  }
  let result = "";
  let characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
  if (caseMode === 1) {
    characters = "abcdefghijklmnopqrstuvwxyz";
  }
  if (caseMode === 2) {
    characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
  }
  if (!isUndefined(excludeCharsList) && excludeCharsList !== null) {
    for (let i = 0; i < excludeCharsList.length; i++) {
      const chCur = excludeCharsList.charAt(i);
      if (characters.indexOf(chCur) !== -1) {
        characters = characters.split(chCur).join("");
      }
    }
  }

  const charactersLength = characters.length;
  for (let i = 0; i < count; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}

function GAddDays(inp: any, count: number) {
  if (isUndefined(inp)) {
    return null;
  }

  if (isString(count)) {
    count = parseInt(count);
  }

  if (isDate(inp)) {
    const tomorrow = new Date(inp);
    tomorrow.setDate(inp.getDate() + count);
    return tomorrow.toJSON();
  }

  return inp !== null ? inp.toJSON() : null;
}

function GTrim(inp: unknown) {
  if (isString(inp) && !isNullOrEmpty(inp)) {
    return inp.trim();
  }
  return "";
}

function GRegex(inp: string, expr: RegExp | string) {
  if (!isNullOrWhiteSpace(expr) && !isNullOrWhiteSpace(inp)) {
    try {
      const re = new RegExp(expr, "i");
      const retval = inp.replace(re, "");
      return retval;
    } catch (ex) {
      log.error("GRegex error: ", { inp, expr, error: ex });
    }
  }
  return "";
}

function FilePickerControlEnabled() {
  if (getInternetExplorerVersion() !== -1) {
    if ("ActiveXObject" in window) {
      /* Do ActiveX Stuff */
      return true;
    } else {
      /* ActiveX doesnt exist, use something else */
      return false;
    }
  }
  return true;
}

export const generationRuleFunctionRegistry = {
  GReturnByCondition,
  GReturnBothNotEmpty,
  GReturnIfNotEmpty,
  GtoLowerCase,
  GtoUpperCase,
  GRemoveSpaces,
  GFirst,
  GLast,
  GJoinBySpaces,
  GJoinByChar,
  GJoinBySpacesF,
  GJoinByCharF,
  GExcludeCharacters,
  GSubstituteCharacters,
  GReturnIfGreater,
  GReturnIfGreaterOrEqual,
  GReturnIfLess,
  GReturnIfLessOrEqual,
  GAddDaysIfLessOrEqual,
  GGetRandomChars,
  GAddDays,
  GTrim,
  GRegex,
  FilePickerControlEnabled,
};
